import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Modal from "react-responsive-modal";
import { Toastr, Button, Input } from "../../../revvComponents";

import { PricebooksActions } from "../../../actions";
import { ReactSelect } from "../../../commonComponents";

import { GlobalUtils } from "../../../utils";
import { CURRENCY_SYMBOL } from "../../../constants/common";
// Destructuring
const { handleApiErrMsg } = GlobalUtils;

const { addPriceList } = PricebooksActions;
const currencyDetails = JSON.parse(JSON.stringify(CURRENCY_SYMBOL));
const currencies = [];

const currenciesWithLabel = {
  CNY: "Chinese Yuan (¥ CNY)",
  EUR: "Euro (€ EUR)",
  GBP: "Pound sterling (£ GBP)",
  INR: "Indian rupee (₹ INR)",
  USD: "United States Dollar ($ USD)",
  AUD: "Australian Dollar ($ AUD)",
  CAD: "Canadian Dollar ($ CAD)",
  MXN: "Mexican Peso ($ MXN)",
  SGD: "Singapore Dollar (S$ SGD)",
  ZAR: "South African Rand (R ZAR)",
  TZS: "Tanzania (TSh)",
  UAH: "Uruguayan Peso ($)",
  UGX: "Uganda (Sh)",
  UYU: "Uruguayan Peso ($)",
  UZS: "Uzbekistan (so'm)",
  VEF: "Venezuela (Bs F)",
  VND: "Vietname (₫)",
  VUV: "Vanuatu (Vt)",
  WST: "Samoa (T)",
  XAF: "Central Africa (₣)",
  XCD: "Eastern Caribbean States ($)",
  XPF: "Central Pacific Franc  (₣)",
  YER: "Rials (﷼)",
  ZMW: "Zambia (ZK)",
  PHP: "Philippine Peso (₱)",
};

Object.entries(currencyDetails).forEach(([key, value]) => {
  currencies.push({
    id: currencies.length + 1,
    value: key,
    label: currenciesWithLabel[key]
      ? currenciesWithLabel[key]
      : `${key} (${value})`,
  });
});

class AddPricebook extends Component {
  state = { name: "", desc: "", currency: "", disableAdd: true };

  _onChange = (value, field) => {
    this.setState({ [field]: value }, () => this._validateFields());
  };

  _findSelectValue = (stateField, options) => {
    const selectedValue = options.find(
      option => option.value === this.state[stateField],
    );
    if (selectedValue) {
      return selectedValue.label;
    }
    return "";
  };

  _validateFields = () => {
    const { name, desc, currency } = this.state;
    if (![name, desc, currency].includes("")) {
      this.setState({ disableAdd: false });
    }
  };

  _savePricebook = () => {
    const { name, desc, currency } = this.state;
    const pb = {
      name,
      desc,
      currency,
    };
    this.props
      .addPriceList(pb)
      .then(response => {
        Toastr.showToastr({
          type: "success",
          message: "Price Book added successfully",
          timeout: 2000,
        });
        this.props.toggleAddPBPopup(false);
        this.props.history.push(`/pricebooks/${response.PriceList.id}`);
      })
      .catch(err => {
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(err),
          timeout: 3000,
        });
      });
  };

  render() {
    const { name, desc, disableAdd } = this.state;
    return (
      <Modal
        open
        onClose={() => this.props.toggleAddPBPopup(false)}
        center
        closeOnOverlayClick={false}>
        <div className="pricingmethodwrapper-wrapper">
          <div className="pricingmethod-title">
            <span className="pricingmethodwrapper-header">
              Create New Price Book
            </span>
          </div>
        </div>
        <div className="addpbitem-div-wrapper item-full-span">
          <span className="addproduct-label">
            Pricebook Name
            <span className="required-input">*</span>
          </span>
          <Input
            autoFocus
            placeholder="Enter a name for your price book."
            value={name}
            onChange={e => this._onChange(e.target.value, "name")}
            data-test="addpricebook-name-input"
          />
        </div>
        <div className="addpbitem-div-wrapper item-full-span">
          <span className="addproduct-label">
            Decription
            <span className="required-input">*</span>
          </span>
          <Input
            placeholder="Enter a description for your price book."
            value={desc}
            onChange={e => this._onChange(e.target.value, "desc")}
            data-test="addpricebook-desc-input"
          />
        </div>
        <div className="addpbitem-div-wrapper item-full-span">
          <span className="addproduct-label">
            Currency
            <span className="required-input">*</span>
          </span>
          <ReactSelect
            isSearchable
            onChange={value => this._onChange(value.value, "currency")}
            options={currencies}
            value={this._findSelectValue("currency", currencies)}
            placeholder=""
            valueKey="value"
            labelKey="label"
            data-test="addpricebook-reactselect"
          />
        </div>
        <section className="createquotepopup-footer popup-footer clearfix">
          <div className="footer-actions">
            <Button
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              onClick={() => this.props.toggleAddPBPopup(false)}
              data-test="addpricebook-cancel-btn">
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={() => this._savePricebook()}
              disabled={disableAdd}
              data-test="addpricebook-add-btn">
              Add
            </Button>
          </div>
        </section>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  addPriceList: pb => addPriceList(pb),
};

export default connect(null, mapDispatchToProps)(withRouter(AddPricebook));
